import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

const CACHED_BRAND_KEY = "stream_brand_cache";
const DEFAULT_BRAND = { application_name: "STREAM", slogan: "VAŠA IDEJA. NAŠA TEHNOLOGIJA.", secondary_slogan: "Zajedno stvaramo budućnost!", logo_url: "" };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [branding, setBranding] = useState(() => {
    try { const cached = localStorage.getItem(CACHED_BRAND_KEY); if (cached) return { ...DEFAULT_BRAND, ...JSON.parse(cached) }; } catch {}
    return DEFAULT_BRAND;
  });

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("stream_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { localStorage.removeItem("stream_token"); setUser(null); }
    setLoading(false);
  }, []);

  const loadBranding = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding((b) => ({ ...b, ...data }));
      try { localStorage.setItem(CACHED_BRAND_KEY, JSON.stringify(data)); } catch {}
    } catch {}
  }, []);

  useEffect(() => { loadMe(); loadBranding(); }, [loadMe, loadBranding]);

  const login = async (identifier, password, isAdmin = false) => {
    const path = isAdmin ? "/auth/admin/login" : "/auth/login";
    const { data } = await api.post(path, { identifier, password });
    localStorage.setItem("stream_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = (token, u) => {
    localStorage.setItem("stream_token", token);
    setUser(u);
    return u;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("stream_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem("stream_token"); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, loginWithToken, register, logout, branding, refreshBranding: loadBranding, refreshUser: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
